import React, { ReactElement } from 'react';
import './Calibration.scss';
import { Button } from '@material-ui/core';
import { useBem } from '../Bem';

type Action = {
  title: string;
  method: (...arg: any[]) => void;
};
type Props = {
  type: string | ReactElement;
  message: ReactElement | string;
  action: Action;
};
export const InfoScreen = ({ type, message, action }: Props) => {
  const bem = useBem('calibration');

  return (
    <section className={bem.elem('info-box').cls()}>
      <div className={bem.elem('info-item').cls()}>
        <p className={bem.elem('info-title').cls()}> {type} </p>
        <p className={bem.elem('info-message').cls()}> {message}</p>
        <div className={bem.elem('info-button-container').cls()}>
          <Button variant="outlined" color="primary" type={'button'} onClick={action.method}>
            {action.title}
          </Button>
        </div>
      </div>
    </section>
  );
};
